import { Component } from 'react'
import styled from 'glamorous'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { withRouter } from 'react-router-dom'
import { map, filter } from 'lodash'

import { $, div, getLocationQuery } from 'utils'
import { client } from 'config'
import { Icon, HeaderRow, Checkbox, PhotoListSelector, InfoRow, ImagePure, FlatButton } from 'components'
import { DESCRIPTORS as query } from 'queries'
import { withConsumer } from 'store'

import { getVariables } from './index'


const AnimatedContainer = styled.div({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  background: '#fff',
  zIndex: 1010,
  transform: 'translateX(100%)',
  animation: 'var(--animationSlideIn)',
}, ({ fixed, shown }) => {
  const fixedStyles = fixed ? {
    position: 'fixed',
    left: 'auto',
    right: 0,
    width: 368
  } : {}
  const closeStyles = !shown ? {
    animation: 'var(--animationSlideOut)',
  } : {}
  return [fixedStyles, closeStyles]
}, 'ExtractPanel')

const ExtractingContainer = styled.div({
  position: 'absolute',
  height: '100%',
  width: '100%',
}, 'cls-ExtractContainer')

const InnerContainer = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 0 75px',
})

const Header = styled.div({
  padding: '0 30px'
})

const AgeGenderContainer = styled.div({
  display: 'flex',
  marginLeft: 30
})

const AgeGender = styled.div({
  marginLeft: 10,
  marginBottom: 32,
  fontSize: 14,
  fontWeight: 'bold'
})

const MainPhotoContainer = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  margin: '25px 30px',
})

const ListItemDescription = styled.div({
  margin: '0 30px',
  color: 'var(--grey)',
  lineHeight: 1.43,
})

// for extracted photos

const ExtractedFaces = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  margin: '0 30px'
})

const ExtractedFace = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  marginRight: 15,
  marginBottom: 15
})

const OneFaceAttributes = styled.div({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 30px'
})

const Attributes = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 15
})

const FacesToExtract = styled.div({
  borderTop: 'var(--border)',
  padding: '25px 30px'
})

const PhotoListContainer = styled.div({
  marginTop: 30,
  marginLeft: -2,
})

const hasMultipleExtract = false
const hint = 'You can extract information about the field and the age of the loaded face'

class ExtractPage extends Component {

  state = {
    withAgeGender: false,
    facesToExtract: [],
    shown: true
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.closePanel() }, 300)
  }

  extractFace = () => {
    const { file, onExtract } = this.props
    const { withAgeGender } = this.state
    const formData  = new FormData()
    formData.append('file', file)
    return fetch(`/extract${withAgeGender ? '?estimate_attributes=1' : ''}`, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    })
      .then((response) => {
        response.json().then(data => {
          if (!data.faces) {
            this.props.setErrorMessage(data.detail)
            return null
          }
          const variables = getVariables(getLocationQuery(this.props.location))
          const queryData = client.cache.readQuery({ query, variables })
          queryData.descriptors.items = [
            ...data.faces.map(face => ({
              uuid: face.id,
              portrait: `/portrait/${face.id}`,
              __typename: "Descriptor"
            })),
            ...queryData.descriptors.items
          ]
          queryData.descriptors.items = filter(queryData.descriptors.items, (item, i) => i < variables.limit)
          queryData.descriptors.count = queryData.descriptors.count + data.faces.length

          client.cache.writeQuery({ query, variables, data: queryData })
          client.queryManager.broadcastQueries()
          onExtract({ extractedFaces: data.faces, extracted: true })
          return data
        }).then((data) => this.props.history.push(`/faces/${data.faces[0].id}`))
      })
  }

  handleSelect = (list) => {
    const { facesToExtract } = this.state
    const foundFace = facesToExtract.find(face => face === list)
    if (!foundFace && foundFace !== 0)
      this.setState({ facesToExtract: facesToExtract.concat(list) })
    else
      this.setState({ facesToExtract: facesToExtract.filter(face => list !== face) })
  }


  render = () => {
    const { photo, extractedFaces, extracted, fixed } = this.props
    const { withAgeGender, facesToExtract, shown } = this.state

    return (
      $(AnimatedContainer, { shown, fixed },
        $(ExtractingContainer,
          $(InnerContainer,
            $(Header,
              $(HeaderRow, { label: 'Extracting info' },
                div({ onClick: this.close },
                  $(Icon, { type: 'close', color: 'var(--lightGrey)' })
                ),
              ),
            ),
            !extracted && $(ListItemDescription, hint),
            $(MainPhotoContainer,
              $(ImagePure, {
                src: photo,
                width: 320,
                height: 'auto',
              })
            ),
            // todo: returned back after support of multiple faces
            hasMultipleExtract &&
              $(FacesToExtract,
                $(HeaderRow, { label: 'Faces to extract', count: facesToExtract.length }),
                $(PhotoListContainer,
                  $(PhotoListSelector, {
                    items: [],
                    selected: facesToExtract,
                    onSelect: this.handleSelect,
                  }),
                )
              ),
            extractedFaces.length === 1 && !!extractedFaces[0].attributes &&
              $(OneFaceAttributes,
                $(InfoRow, { name: 'Age:', value: extractedFaces[0].attributes.age }),
                $(InfoRow, {
                  name: 'Gender:',
                  value: getGender(extractedFaces[0].attributes.gender)
                }),
              ),
            extractedFaces.length > 1 &&
              $(ExtractedFaces,
                map(extractedFaces, face =>
                  $(ExtractedFace, { key: face.id },
                    $(ImagePure, {
                      src: `/portrait/${face.id}`,
                      width: 62,
                      height: 80
                    }),
                    !!face.attributes &&
                      $(Attributes,
                        $(InfoRow, { name: 'Age:', value: face.attributes.age }),
                        $(InfoRow, {
                          name: 'Gender:',
                          value: getGender(face.attributes.gender)
                        }),
                      )
                  )
                )
              ),
            !extracted &&
              $(AgeGenderContainer,
                $(Checkbox, {
                  selected: withAgeGender,
                  onChange: () => this.setState({ withAgeGender: !withAgeGender }),
                  label: $(AgeGender, 'Age & Gender')
                }),
              ),
          ),
          !extracted &&
            $(FlatButton, {
              onClick: this.extractFace,
              text: 'Extract'
            }),
        )
      )
    )
  }
}

export default withRouter(withConsumer(ExtractPage))

function getGender(gender) {
  const percent = gender >= 0.5 ? gender : 1 - gender
  const genderValue = gender >= 0.5 ? 'Male' : 'Female'
  return `${(percent * 100).toFixed(1)}% ${genderValue}`
}


// WEBPACK FOOTER //
// ./src/pages/Faces/ExtractPage.js